import { createElement, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NoAdsVariantEnum } from '@/constants/common';
import { useTheme } from '@/providers/ThemeProvider/ThemeProvider';

import {
  NoAdsBookmark,
  NoAdsCompany,
  NoAdsProfile,
  NoAdsResult,
  NoAdsSimilarVacancies
} from './components';
import { NoAdsProps } from './NoAds.types';

export const NoAds: FC<NoAdsProps> = ({ variant }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const isDark = theme === 'dark';

  const variants = {
    [NoAdsVariantEnum.RESULT]: NoAdsResult,
    [NoAdsVariantEnum.PROFILE]: NoAdsProfile,
    [NoAdsVariantEnum.BOOKMARKS]: NoAdsBookmark,
    [NoAdsVariantEnum.COMPANY]: NoAdsCompany,
    [NoAdsVariantEnum.SIMILAR_VACANCIES]: NoAdsSimilarVacancies
  };

  if (variant === NoAdsVariantEnum.NONE) return null;
  return createElement(variants[variant], { t, isDark });
};
